import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, HostListener, OnInit, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ObservableBaseComponent } from '@scl/shared/components/observable-base.component';
import { UserRole } from '../../../core-module/models/role';
import { RoutingService } from '../../../shared-module/services/routing.service';


// Define interfaces for menu items
interface MenuItem {
  id?: number;
  name: string;
  navCommands?: any[];
  expanded: boolean;
  subItems: SubMenuItem[];
  roles: UserRole[];
  permissions?: string[];
  order?: number;
}

interface SubMenuItem {
  name: string;
  imgSrc: string;
  description: string;
  navCommands: any[];
  col: number;
  roles?: UserRole[];
  permissions?: string[];
  externalLink?: string;
}

@Component({
  selector: '[app-main-nav-menu]',
  imports: [
    CommonModule,
    RouterModule,
  ],
  templateUrl: './main-nav-menu.component.html',
  styleUrls: ['./main-nav-menu.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainNavMenuComponent extends ObservableBaseComponent implements OnInit {

  private routingService = inject(RoutingService);
  private elementRef = inject(ElementRef);

  menuItems = input<any[]>([]);

  expandedItem: MenuItem | null = null;

  @HostListener('document:click', ['$event'])
  onClickout(event: Event) {
    if (this.elementRef.nativeElement.contains(event.target)) {
      // inside, do nothing.
    } else {
      if (this.expandedItem) {
        this.expandedItem.expanded = false;
      }
    }
  }

  ngOnInit() {
    
  }

  onMainItemClick(item: MenuItem) {
    // click on another item.
    if (this.expandedItem
      && this.expandedItem.name != item.name) {
      this.expandedItem.expanded = false;
    }

    if (item.subItems && item.subItems.length > 0) {
      item.expanded = !item.expanded;
      this.expandedItem = item;
    } else if (item.navCommands) {
      this.routingService.navigate(item.navCommands);
    }
  }

  onSubItemClick(mainItem: MenuItem) {
    mainItem.expanded = false;
    if (this.expandedItem) {
      this.expandedItem.expanded = false;
    }
  }



}
